import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import { AppState } from '../../../store/reducers/root';
import {
  getData,
  getEvents,
  getIsOpen,
  getParseDates,
  getTemplate,
  getVariables,
} from '../../../store/selectors/review';
import { isDarkTheme } from '../../../store/selectors/theme';
import review from '../../../store/slices/review';

import ReviewDialog from './ReviewDialog';

const mapStateToProps = (state: AppState) => ({
  isOpen: getIsOpen(state),
  template: getTemplate(state),
  data: JSON.stringify(getData(state)),
  variables: getVariables(state),
  events: getEvents(state),
  parseDates: getParseDates(state),
  isDarkMode: isDarkTheme(state),
});

const connector = connect(mapStateToProps, dispatch => ({
  onClose: () => dispatch(review.close()),
}));

export type TReviewConnectorProps = ConnectedProps<typeof connector>;

export default connector(ReviewDialog);
